import { useAppSelector } from "hooks";

// Provisional: el acceso a quizzes se decide solo por el perfil del operador mientras
// se define su fuente de permisos. Admin gestiona todo; cualquier otro perfil solo lee.
const useQuizAccess = () => {
    const profile = useAppSelector(({ user }) => user.data.profile);
    const canManage = String(profile ?? "").trim().toLowerCase() === "admin";
    return { canManage };
};

export default useQuizAccess;
